import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Mixpris = lazy(() => import("@/pages/elavtal/Mixpris"));

export const Route = createFileRoute("/elavtal/mixpris")({
  head: () => seoHead("/elavtal/mixpris", { description: "Mixavtal kombinerar trygghet i fast pris med möjligheten att tjäna på låga spotpriser. Perfekt för dig som vill sprida risken." }),
  component: () => <Mixpris />,
});
